import { createTypes } from 'redux-create-types';
import { fromType, } from 'kreighter';

const namespace = 'user';

export const userActions = createTypes([
    'set',
    'remove',
    'setAttachments',
    'updateUserPicture',
    'changeEmail'
], namespace)

export const userActionCreators = {
    set: fromType(userActions.set, ['user']),
    remove: fromType(userActions.remove),
    updateUserPicture: fromType(userActions.updateUserPicture, ['image']),
    setAttachments: fromType(userActions.setAttachments, ['attachments']),
    changeEmail: fromType(userActions.changeEmail, ['email']),
}


export const forumUserActions = createTypes([
    'create',
], namespace)

export const ForumUserActionCreators = {
    create: fromType(forumUserActions.create, ['ForumUser']),
}
